import { GoogleMapsSignedUrlsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useSignGoogleUrl = (rawUrl: string) => {
  const { data, loading } = useQuery(GoogleMapsSignedUrlsDocument, {
    variables: { rawUrl },
  })

  const signedUrl = data?.attendance.googleMapsSignedUrlsConnection.nodes[0]?.signedUrl

  return { signedUrl, loading }
}
